import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from 'store';

import { initialState } from './staffFeedback.types';
import { staffFeedbackApi } from './staffFeedbackApi';

const staffFeedbackSlice = createSlice({
  extraReducers: (builder) => {
    builder.addMatcher(
      staffFeedbackApi.endpoints.getStaffFeedbacks.matchFulfilled,
      (state, action) => {
        if (action.payload) {
          state.data = action.payload.data;
          state.info = action.payload.info;
        }
      }
    );
  },
  initialState: initialState,
  name: 'staffFeedback',
  reducers: {}
});

export const selectStaffFeedback = (state: RootState) => state.staffFeedback;

export default staffFeedbackSlice.reducer;
